import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './App.css'; // Ensure you have appropriate CSS for styling
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa'; // Import icons
import { FaBars } from 'react-icons/fa'; // Import the icon


const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
  
    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
    };
  
    const handleScroll = (event, targetId) => {
      event.preventDefault();
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
      setMenuOpen(false); // Close the menu after clicking a link
    };
  
    return (
      <header className="App-header">
        <div className="header-content">
          <Link to="/">
            <img src="/SG EV Hub Icon.png" alt="SG EV Hub Icon" className="app-icon" />
          </Link>
          <nav>
          <ul className={menuOpen ? 'open' : ''}>
          
              <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li> {/* Use Link to navigate to Home */}
              <li><Link to="/AboutUs" onClick={() => setMenuOpen(false)}>About Us</Link></li> {/* Use Link to navigate to Home */}
              <li><Link to="/ContactUs" onClick={() => setMenuOpen(false)}>Contact Us</Link></li> {/* Use Link to navigate to Home */}
              <li><Link to="/FAQs" onClick={() => setMenuOpen(false)}>FAQs</Link></li> {/* Use Link to navigate to Home */}
              
              <li className="header-links">
                <a href="https://www.facebook.com/people/SG-EV-HUB/61566980022806/">
                  <FaFacebook className="social-icon" />
                </a>
                
                <a href="https://www.instagram.com/sg_ev_hub/">
                  <FaInstagram className="social-icon" />
                </a>
              </li>
            </ul>
          </nav>
          
                <div className="mobile-icon" onClick={toggleMenu}>
                  <FaBars style={{ width: '30px', color:'#f16622' }} />
                </div>
             
        </div>
      </header>
    );
}

export default Header;